import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './components/AuthProvider';
import { SiteActionsProvider } from './components/site/SiteActions';
import { ToastProvider } from './components/ui/Toast';
import './index.css';
import './i18n/config'; // Initialize i18n
import './config/aws'; // Initialize AWS Amplify

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <ToastProvider>
                <SiteActionsProvider>
                  <App />
                </SiteActionsProvider>
              </ToastProvider>
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </HelmetProvider>
    </Suspense>
  </StrictMode>
);
